import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function CategoryNav() {
  return (
    <section className="py-10 md:py-14 px-4 md:px-6" aria-labelledby="category-title">
      <div className="mx-auto">
        <div className="flex items-center justify-between mb-6 md:mb-8">
          <h3 id="category-title" className="text-xl md:text-2xl font-heading text-foreground-950">
            漫画分类
          </h3>
          <Link
            to="/category/romance"
            className="flex items-center gap-1 text-sm text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap"
          >
            全部分类
            <i className="ri-arrow-right-s-line text-base"></i>
          </Link>
        </div>
        <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-5 lg:grid-cols-10 gap-3">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className="flex flex-col items-center gap-2 p-4 rounded-lg bg-background-100 hover:bg-background-200 transition-all duration-200 group cursor-pointer"
            >
              <div className="w-10 h-10 md:w-12 md:h-12 rounded-full bg-primary-500/10 flex items-center justify-center group-hover:bg-primary-500/20 transition-colors">
                <i className={`${cat.icon} text-lg md:text-xl text-primary-500`}></i>
              </div>
              <span className="text-xs md:text-sm text-foreground-700 group-hover:text-primary-500 transition-colors whitespace-nowrap">
                {cat.name}
              </span>
              <span className="text-xs text-foreground-500">{cat.count}部</span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}